import Tooltip from '@mui/material/Tooltip';
import CakeIcon from '@mui/icons-material/Cake';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import LocalPizzaIcon from '@mui/icons-material/LocalPizza';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocalDrinkIcon from '@mui/icons-material/LocalDrink';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import dayjs from 'dayjs';

function UpgradeSymbols({ upgrades = [], manualUpgrades = [], voucherSoldDate }) {
  const shownUpgrades = [...upgrades, manualUpgrades];

  return (
    <>
      {voucherSoldDate && voucherSoldDate !== null ? (
        <Tooltip title={dayjs(voucherSoldDate).format('[Gekauft:] DD.MM.YYYY HH:mm')}>
          <LocalActivityIcon sx={{ color: 'lightgrey' }} />
        </Tooltip>
      ) : (
        ''
      )}
      {shownUpgrades.includes('childBirthday') ? <CakeIcon sx={{ color: 'orange' }} /> : ''}
      {shownUpgrades.includes('childBirthdayFull') ? <CakeIcon sx={{ color: 'red' }} /> : ''}
      {shownUpgrades.includes('teenBirthday') ? <CakeIcon sx={{ color: 'green' }} /> : ''}
      {shownUpgrades.includes('adultBirthday') ? <CakeIcon /> : ''}
      {shownUpgrades.includes('bachelorParty') ? <LocalBarIcon sx={{ color: 'lightblue' }} /> : ''}
      {shownUpgrades.includes('bag') ? <ShoppingBagIcon sx={{ color: 'yellow' }} /> : ''}
      {shownUpgrades.includes('pizza') ? <LocalPizzaIcon sx={{ color: 'brown' }} /> : ''}
      {shownUpgrades.includes('dateNight') ? <FavoriteIcon sx={{ color: 'hotpink' }} /> : ''}
      {/* Bundle, not a drinks flat — deliberately a package icon rather than
          the cup, and named so the symbol is unambiguous on hover. */}
      {shownUpgrades.includes('maxiPackage') ? (
        <Tooltip title='Maxi-Paket'>
          <Inventory2Icon sx={{ color: 'teal' }} />
        </Tooltip>
      ) : (
        ''
      )}
      {shownUpgrades.includes('drinks') ? <LocalDrinkIcon sx={{ color: 'dodgerblue' }} /> : ''}
      {shownUpgrades.includes('food') ? <FastfoodIcon sx={{ color: 'darkorange' }} /> : ''}
      {shownUpgrades.includes('photo') ? <PhotoCameraIcon sx={{ color: 'mediumpurple' }} /> : ''}
    </>
  );
}

export default UpgradeSymbols;
